import React, { Component } from 'react';
import { Route } from 'react-router';

import * as Colyseus from "colyseus.js";
import Trophy from "../images/Trophy.png";
//import Lottie from 'react-lottie';
import nosleep from 'nosleep.js';
import "animate.css";

import Loading from "components/Loading";
import ErrorModal from './Utility/ErrorModal';
import logo from "images/logo.png";
import styles from 'components/ClientStyles.module.scss';
import { testRoomState } from "constants/testData";
import { GameStates, CatchphraseServerInMessages, CatchphraseServerOutMessages } from "constants/constants"
import Player from "components/Player";
import ClientMenuIcon from './ClientMenuIcon';
import Hints from 'components/Shared/Hints/Hints';
import GameConfigEditor from 'components/GameConfigEditor';
import LetterSlotInput from 'components/LetterSlotInput';
import { isTerminalByCode, retryDelayForCode, isTerminalReconnectError } from "services/connectionManager";

var noSleep = new nosleep();
//var supportsVibrate = "vibrate" in navigator;
const gameId = "catchphrase";

export class Client extends Component {
    static displayName = Client.name;

    constructor(props) {
        super(props);

        this.client = new Colyseus.Client(process.env.REACT_APP_GAME_SERVER_URL);
        this.state = {
            roomId: 0,
            room: null,
            myId: null,
            //myId: "1", //debug
            roomState: null,
            //roomState: testRoomState, //Debug
            redirect: null,
            redirectURL: "",
            isPaused: false,
            answerText: "",
            isRecording: false,
            //connected: true, //debug

            tickedSkipTutorial: true,
            voteSkipTutorial: false,
            showHints: false,
            platform: null,
        };
        this.locationCheckInterval = null;
        this.mediaRecorderRef = null;
        this.audioChunksRef = [];
        this.streamRef = null;
        this.isRecordingRef = false;
        this.autoStopTimerRef = null;
        this.activePointerId = null;
        this.inputRef = React.createRef();
    }

    componentDidMount() {
        this.setTags();
        setTimeout(() => {
            this.doReconnect();
        }, 1500);

        // Add network status listeners
        window.addEventListener('offline', this.handleOffline);
        window.addEventListener('online', this.handleOnline);

        document.addEventListener('click', function enableNoSleep() {
            document.removeEventListener('click', enableNoSleep, false);
            noSleep.enable();
        }, false);

        // Prevent context menu (long-press popup) on mobile
        this.handleContextMenu = (e) => e.preventDefault();
        document.addEventListener('contextmenu', this.handleContextMenu);

        // Prevent pinch-to-zoom (backup for viewport meta)
        this.handleTouchStart = (e) => {
            if (e.touches.length > 1) e.preventDefault();
        };
        document.addEventListener('touchstart', this.handleTouchStart, { passive: false });

        // Swallow Tab key — this is a touch-first game UI with offscreen
        // animated panels. Allowing the browser's default tab-focus behaviour
        // scrolls those panels on-screen. We never rely on keyboard navigation.
        this.handleTabKey = (e) => {
            if (e.key === 'Tab') e.preventDefault();
        };
        document.addEventListener('keydown', this.handleTabKey);

        // Track keyboard visibility via visualViewport to reposition answer section
        this.handleViewportResize = () => {
            const vv = window.visualViewport;
            if (!vv) return;
            const keyboardHeight = window.innerHeight - vv.height;
            document.documentElement.style.setProperty('--keyboard-height', `${keyboardHeight}px`);
        };
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.handleViewportResize);
            window.visualViewport.addEventListener('scroll', this.handleViewportResize);
        }

        //Dev only
        if (window.location.hostname === "localhost") {
            setInterval(() => {
                var iframes = document.querySelectorAll('iframe');
                if (iframes.length > 0) console.log("Developer: ", "react iframe found, trying to remove it");
                for (var i = 0; i < iframes.length; i++) {
                    iframes[i].parentNode.removeChild(iframes[i]);
                }
            }, 1000);
        }
    }

    componentWillUnmount() {
        if (this.handleViewportResize && window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.handleViewportResize);
            window.visualViewport.removeEventListener('scroll', this.handleViewportResize);
        }
        window.removeEventListener('offline', this.handleOffline);
        window.removeEventListener('online', this.handleOnline);
        if (this.handleContextMenu) document.removeEventListener('contextmenu', this.handleContextMenu);
        if (this.handleTouchStart) document.removeEventListener('touchstart', this.handleTouchStart);
        if (this.handleTabKey) document.removeEventListener('keydown', this.handleTabKey);
        if (this.locationCheckInterval) clearInterval(this.locationCheckInterval);
        if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
        if (this.autoStopTimerRef) clearTimeout(this.autoStopTimerRef);
        if (this.streamRef) {
            this.streamRef.getTracks().forEach(track => track.stop());
        }
    }

    setTags() {
        // Tags for debugging (Sentry removed)
    }

    handleOffline = () => {
        console.log('[Client] Network offline detected');
        // Don't call room.leave() — we're offline, let the server detect the WebSocket drop
        // naturally. Calling leave() can race with transport recovery and cause ghost players.
        if (this.locationCheckInterval) clearInterval(this.locationCheckInterval);
        this.setState({ connected: false, isReconnecting: true });
        this.scheduleReconnect(1000);
    };

    handleOnline = () => {
        console.log('[Client] Network online detected');
        this.scheduleReconnect(0);
    };

    scheduleReconnect = (delayMs = 2000) => {
        if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
        this.reconnectTimer = setTimeout(() => this.doReconnect(), delayMs);
    };

    getQueryStringValue(key) {
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    }

    // checking to ensure player is in the right place e.g. in the correct game
    startLocationChecks() {
        this.state.room.send("location_check", { gameId, });
        this.locationCheckInterval = setInterval(() => {
            this.state.room.send("location_check", { gameId, });
        }, 10000);
    }

    skipTutorial() {
        this.state.room.send("vote_skip");
        this.setState({ voteSkipTutorial: true });
    }

    goToLobby(lobbyCode = null) {
        const lobbyUrl = this.getLobbyUrl();
        if (lobbyUrl) {
            // Phones always return via /join — the host's platform (firetv/roku) is
            // irrelevant for the phone URL and syncs through the lobby room state once joined.
            let redirectURL;
            if (lobbyCode) {
                const player = this.state.roomState?.players?.get(this.state.myId);
                const playerName = player?.name || '';
                const playerAvatar = player?.avatar || '';

                redirectURL = `${lobbyUrl}/join?joinRoom=${lobbyCode}`;
                if (playerName) redirectURL += `&name=${encodeURIComponent(playerName)}`;
                if (playerAvatar) redirectURL += `&avatar=${encodeURIComponent(playerAvatar)}`;
            } else {
                redirectURL = lobbyUrl;
            }
            this.setState({ redirectURL });
        }
        localStorage.removeItem('catchphraseLobbyUrl');
        localStorage.removeItem('catchphrase_reconnectToken');
        localStorage.removeItem('catchphrase_sessionId');
        localStorage.removeItem('catchphrase_tokenRoomCode');
        this.state.room?.leave(false);
        if (this.locationCheckInterval) clearInterval(this.locationCheckInterval);
        console.log("going to lobby", this.state.redirectURL);
    }

    signalGoToLobby = () => {
        this.state.room.send("change_game", {});
    }

    getRedirectURL(display = false) {
        const lobbyUrl = this.getLobbyUrl();
        if (display) {
            return process.env.REACT_APP_GAME_CITY_URL_DISPLAY || lobbyUrl;
        }
        return lobbyUrl || process.env.REACT_APP_GAME_CITY_URL;
    }

    /** Get HTTP URL for API calls from WebSocket URL */
    getServerHttpUrl = () => {
        const wsUrl = process.env.REACT_APP_GAME_SERVER_URL || '';
        return wsUrl.replace('ws://', 'http://').replace('wss://', 'https://');
    };

    /** Get room code from URL query param */
    getRoomCodeFromURL = () => {
        return this.getQueryStringValue("code");
    };

    /** Get the lobby URL for return navigation */
    getLobbyUrl = () => {
        let url = localStorage.getItem('catchphraseLobbyUrl');
        if (!url) {
            url = process.env.REACT_APP_GAME_CITY_URL || null;
        }
        if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'https://' + url;
        }
        return url;
    };

    /** Get previous sessionId from localStorage (stored separately for reliable remap on rejoin) */
    getPreviousSessionId = () => {
        const storedSessionId = localStorage.getItem('catchphrase_sessionId');
        if (storedSessionId) {
            return storedSessionId;
        }
        return null;
    };

    /** Get or create a stable uniqueId persisted in localStorage.
     *  This survives join retries where sessionId changes, allowing the server
     *  to detect and remap orphaned players from failed connection attempts. */
    getOrCreateUniqueId = () => {
        // Priority: URL ?uniqueId (from GameCity lobby — required for VIP takeover to match
        // the lobby's player identity) > sessionStorage (per-tab persistence across refresh)
        // > generate fresh. sessionStorage scopes per-tab so two phones in the same browser
        // get independent identities.
        const urlUniqueId = new URLSearchParams(window.location.search).get('uniqueId');
        let uniqueId = urlUniqueId
            || sessionStorage.getItem('catchphrase_uniqueId')
            || ('client_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9));
        try { sessionStorage.setItem('catchphrase_uniqueId', uniqueId); } catch {}
        return uniqueId;
    };

    /** Update reconnection token in URL and localStorage
     * Note: Uses 'reconnect' param, NOT 'token' (which is reserved for JWT host verification)
     */
    updateToken(token, sessionId) {
        try {
            const url = new URL(window.location.href);
            url.searchParams.set('reconnect', token);
            window.history.replaceState(null, '', url.toString());
            localStorage.setItem('catchphrase_reconnectToken', token);
            if (sessionId) {
                localStorage.setItem('catchphrase_sessionId', sessionId);
            }
            // Store the current room code so the stale check can compare correctly
            // (reconnection token uses Colyseus roomId, not the user-facing room code)
            const roomCode = this.getRoomCodeFromURL();
            if (roomCode) {
                localStorage.setItem('catchphrase_tokenRoomCode', roomCode);
            }
        } catch (e) {
            console.warn(e);
        }
    }

    formatTimerDisplay(player) {
        if (!player.catchphraseData) return "NaN";
        const totalSeconds = player.catchphraseData.timer
        const minuets = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minuets}:${String(seconds).padStart(2, '0')}`;
    }

    getCurrentCatchphrase() {
        const catchphraseData = this.state.roomState?.catchphraseData;
        if (!catchphraseData) return null;
        if (catchphraseData.isGridPhrase)
            return catchphraseData.currentGridCatchphrase;

        const revealCount = catchphraseData.revealCount;
        return catchphraseData.currentCatchphrases.at(revealCount);
    }

    getCurrentViewState(player) {
        const catchphraseData = this.state.roomState?.catchphraseData;
        const viewState = catchphraseData?.gameStarted && catchphraseData.gameMode === "teams" && player.catchphraseData?.teamIndex === -1 ? GameStates.SelectingTeams : catchphraseData?.gameState;
        return viewState;
    }

    resetGuess() {
        this.inputRef.current?.blur();
        window.scrollTo(0, 0);
        this.setState({ answerText: "", buzzingIn: false });
    }

    handleTextSubmit = () => {
        const text = this.state.answerText.trim();
        if (!text) return;
        this.inputRef.current?.blur();
        this.state.room?.send(CatchphraseServerInMessages.PlayerGuessed, { guess: text });
        this.setState({ answerText: "" });
    }

    handleAnswerKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleTextSubmit();
        }
    }

    setupMediaRecorder = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    autoGainControl: false,
                    channelCount: 1,
                    sampleRate: { ideal: 16000 },
                    latency: { ideal: 0.01 },
                }
            });
            this.streamRef = stream;
            const mediaRecorder = new MediaRecorder(stream);
            this.mediaRecorderRef = mediaRecorder;

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    this.audioChunksRef.push(event.data);
                }
            };

            mediaRecorder.onstop = async () => {
                const audioBlob = new Blob(this.audioChunksRef, { type: "audio/webm" });
                const base64 = await this.convertBlobToBase64(audioBlob);
                // Send voice answer to server
                this.state.room?.send(CatchphraseServerInMessages.SubmitVoiceAnswer, { audioBase64: base64 });
            };

            console.log("[Client] MediaRecorder initialized for voice input");
        } catch (error) {
            console.warn("[Client] Microphone access error:", error.message);
        }
    }

    startRecording = (e) => {
        if (e) {
            e.preventDefault();
            if (e.pointerId !== undefined && e.target.setPointerCapture) {
                try { e.target.setPointerCapture(e.pointerId); this.activePointerId = e.pointerId; } catch (err) {}
            }
        }
        if (!this.mediaRecorderRef) {
            // Try to set up on first use
            this.setupMediaRecorder().then(() => {
                if (this.mediaRecorderRef) this.startRecording();
            });
            return;
        }
        if (this.isRecordingRef) return;

        this.audioChunksRef = [];
        this.mediaRecorderRef.start();
        this.isRecordingRef = true;
        this.setState({ isRecording: true });

        // Pause buzz timer while recording
        this.state.room?.send(CatchphraseServerInMessages.PauseBuzzInTimer, {});

        if ("vibrate" in navigator) navigator.vibrate(100);

        // Auto-stop after 5 seconds
        this.autoStopTimerRef = setTimeout(() => {
            this.stopRecording();
        }, 5000);
    }

    stopRecording = (e) => {
        if (e) e.preventDefault();
        if (this.activePointerId !== null && e?.target?.releasePointerCapture) {
            try { e.target.releasePointerCapture(this.activePointerId); } catch (err) {}
            this.activePointerId = null;
        }
        if (!this.isRecordingRef) return;

        this.isRecordingRef = false;
        this.setState({ isRecording: false });

        if (this.autoStopTimerRef) {
            clearTimeout(this.autoStopTimerRef);
            this.autoStopTimerRef = null;
        }

        if ("vibrate" in navigator) navigator.vibrate([50, 50, 50]);

        setTimeout(() => {
            if (this.mediaRecorderRef && this.mediaRecorderRef.state !== "inactive") {
                this.mediaRecorderRef.stop();
            }
        }, 400);
    }

    convertBlobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => resolve(reader.result.split(",")[1]);
            reader.onerror = reject;
        });
    }

    signalbuzzIn() {
        console.log("buzzing in")
        const catchphraseData = this.state.roomState?.catchphraseData;
        if (catchphraseData?.gridSelectionActive) {
            this.state.room?.send(CatchphraseServerInMessages.SelectGridSegment, {});
            this.setState({ buzzingIn: true });
        } else {
            this.state.room?.send(CatchphraseServerInMessages.PlayerBuzzedIn, {});
            this.setState({ buzzingIn: true, answerText: "" });
            const answerMode = this.state.roomState?.catchphraseData?.answerMode;
            if (answerMode === "exact") {
                // Focus the letter-slot input inside the user-gesture so the phone
                // keyboard actually opens. The input is pre-mounted (hidden) for this.
                if (typeof this._focusLetterSlots === 'function') this._focusLetterSlots();
            } else {
                // Request microphone permission on buzz-in (user gesture required by browsers).
                if (!this.mediaRecorderRef) this.setupMediaRecorder();
            }
        }
    }

    signalSelectedTeam(index) {
        console.log("selected team", index);
        const me = this.state.roomState.players.get(this.state.myId)
        this.state.room?.send(CatchphraseServerInMessages.TeamSelected, { teamIndex: index, removeFromTeamIndex: me.catchphraseData?.teamIndex })
    }

    signalSubmitGuess() {
        this.handleTextSubmit();
    }

    signalStartGame = (confirm = false) => {
        const players = this.state.roomState?.players ? Array.from(this.state.roomState.players.values()) : null;
        let allConnected = players.every(p => p.connected);
        console.log("allConnected", allConnected);
        if (!confirm && !allConnected) {
            this.setState({ showStartWarning: true });
        } else {
            this.setState({ showStartWarning: false })
            console.log("sending start game")
            this.state.room?.send("begin_game", { skipTutorial: this.state.tickedSkipTutorial, });
        }
    }

    signalUpdateGameConfig = (patch) => {
        this.state.room?.send(CatchphraseServerInMessages.UpdateGameConfig, patch);
    }

    // Defensive: claim the editor seat if it's empty. Used both as a recovery mechanism by
    // the GameConfigEditor (auto-claim after a short delay if nobody has the seat).
    signalClaimEditor = () => {
        this.state.room?.send(CatchphraseServerInMessages.OpenGameConfig, {});
    }

    signalBackToMenu = () => {
        this.state.room?.send(CatchphraseServerInMessages.BackToMenu, {});
    }

    signalConfirmGameConfig = () => {
        this.state.room?.send(CatchphraseServerInMessages.ConfirmGameConfig, {});
    }

    signalSkipIntro = () => {
        this.state.room.send(CatchphraseServerInMessages.SkipRoundIntro, {});
    }

    signalPlayAgain = (confirm = false) => {
        const players = this.state.roomState?.players ? Array.from(this.state.roomState.players.values()) : null;
        let allConnected = players.every(p => p.connected);

        if (!confirm && !allConnected) {
            this.setState({ showStartWarning: true });
        } else {
            this.setState({ showStartWarning: false })
            this.state.room?.send(CatchphraseServerInMessages.PlayAgain, {});
        }
    }

    signalPass = () => {
        this.state.room?.send(CatchphraseServerInMessages.Pass, {});
    }

    signalFinishTeamsSelection = () => {
        this.state.room?.send(CatchphraseServerInMessages.FinishTeamsSelection, {});
    }

    toggleSkipTutorial = (e) => {
        this.setState({ tickedSkipTutorial: e.target.checked });
    }

    closeStartWarning = () => {
        this.setState({ showStartWarning: false });
    }

    confirmStartGame = () => {
        this.signalStartGame(true);
    }

    confirmPlayAgain = () => {
        this.signalPlayAgain(true);
    }

    /** Join room by code with proper verification and retry logic */
    joinRoomByCode = async (roomCode, retryCount = 0) => {
        // Slow TVs (LG webOS especially) can take 20–40s to boot Catchphrase and create the
        // Colyseus room. Total budget is MAX_RETRIES * RETRY_DELAY before we give up and
        // redirect the player back to the lobby. 60s gives the host plenty of headroom.
        const MAX_RETRIES = 30;
        const RETRY_DELAY = 2000;

        // Store lobby URL if provided
        const lobbyUrl = this.getQueryStringValue('lobbyUrl');
        if (lobbyUrl) {
            localStorage.setItem('catchphraseLobbyUrl', decodeURIComponent(lobbyUrl));
        }
        const playerName = this.getQueryStringValue("name") || `Player${Math.floor(Math.random() * 1000)}`;
        const playerAvatar = this.getQueryStringValue("avatar") || '';

        console.log(`[Client] Joining room ${roomCode} as ${playerName} (attempt ${retryCount + 1}/${MAX_RETRIES + 1})`);

        // Check if room exists at Catchphrase server
        const serverUrl = this.getServerHttpUrl() || 'http://localhost:3040';
        let roomId = null;

        try {
            const checkResponse = await fetch(`${serverUrl}/api/room-exists/${roomCode}`);
            const checkData = await checkResponse.json();
            console.log(`[Client] Room check for ${roomCode}:`, checkData);

            if (!checkData.exists) {
                if (retryCount < MAX_RETRIES) {
                    console.log(`[Client] Room ${roomCode} not found, retrying in ${RETRY_DELAY}ms...`);
                    setTimeout(() => this.joinRoomByCode(roomCode, retryCount + 1), RETRY_DELAY);
                    return;
                }

                console.log(`[Client] Room ${roomCode} not found after ${MAX_RETRIES + 1} attempts, redirecting to lobby`);
                this.goToLobby();
                return;
            }

            roomId = checkData.roomId;
        } catch (e) {
            console.warn('[Client] Could not check room existence, attempting join anyway:', e);
        }

        const options = {
            roomCode: roomCode,
            name: playerName,
            avatar: playerAvatar,
            isHost: false,
            previousSessionId: this.getPreviousSessionId(),
            uniqueId: this.getOrCreateUniqueId(),
        };

        // Use joinById if we have a roomId, otherwise fall back to joinOrCreate
        const joinPromise = roomId
            ? this.client.joinById(roomId, options)
            : this.client.joinOrCreate('catchphrase_room', options);

        joinPromise.then(room => {
            console.log(`[Client] Joined room ${room.name}`);
            this.setState({ room: room, roomId: room.roomId, myId: room.sessionId, reconnectionToken: room.reconnectionToken });
            this.updateToken(room.reconnectionToken, room.sessionId);
            room.send("update_player_token", { reconnectionToken: room.reconnectionToken });
            this.setupRoomListeners(room);
        }).catch(e => {
            console.error('[Client] Error joining room:', e);
            this.setState({ connected: false });
            if (retryCount < MAX_RETRIES) {
                setTimeout(() => this.joinRoomByCode(roomCode, retryCount + 1), RETRY_DELAY);
            } else {
                console.log(`[Client] Failed to join after ${MAX_RETRIES + 1} attempts, redirecting to lobby`);
                this.goToLobby();
            }
        });
    };

    /** Setup room event listeners (shared between reconnect and join) */
    setupRoomListeners = (room) => {
        const $ = Colyseus.getStateCallbacks(room);

        room.onStateChange.once((roomState) => {
            console.log("this is the first room state!", roomState);
            const player = roomState.players.get(room.sessionId);
            if (!player) {
                console.warn('[Client] Player not found in room state');
            }
            const stateUpdate = { roomState: roomState, connected: true, hostConnected: !!roomState.hostConnected };
            if (roomState.platform && roomState.platform !== 'web') {
                stateUpdate.platform = roomState.platform;
            }
            this.setState(stateUpdate);
            $(room.state).listen("hostConnected", (value) => {
                this.setState({ hostConnected: value });
            });

            this.startLocationChecks();
        });

        room.onStateChange((state) => {
            console.log("onStateChange", state);
            const stateUpdate = { roomState: state };
            if (state.platform && state.platform !== 'web') {
                stateUpdate.platform = state.platform;
            }
            this.setState(stateUpdate);
        });

        room.onMessage("show_tutorial", (message) => {
            console.log("show_tutorial", "received on", room.name, message);
            this.setState({ voteSkipTutorial: false });
        });

        room.onMessage("end_tutorial", (message) => {
            console.log("end_tutorial", "received on", room.name, message);
        });

        room.onMessage("game_starting", (message) => {
            console.log("game_starting", "received on", room.name, message);
            if (message.gameId !== gameId) {
                this.goToLobby();
            }
            // Pre-request microphone permission so the prompt doesn't appear mid-game.
            // Exact mode never uses voice — skip the mic setup so the player isn't prompted.
            const answerMode = this.state.roomState?.catchphraseData?.answerMode;
            if (answerMode !== "exact") {
                this.setupMediaRecorder();
            }
        });

        room.onMessage(CatchphraseServerOutMessages.RevealAnswer, (message) => {
            console.log("reveal_answer", "received on", room.name, message);
            this.resetGuess();
        });

        room.onMessage(CatchphraseServerOutMessages.StartPhrase, (message) => {
            console.log("start_round", "received on", room.name, message);
            this.resetGuess();
        });

        room.onMessage(CatchphraseServerOutMessages.PlayerGuessed, (message) => {
            console.log("player_guessed", "received on", room.name, message);
            if (message.playerId === this.state.myId) this.resetGuess();
        });

        room.onMessage(CatchphraseServerOutMessages.BuzzerTimedOut, (message) => {
            console.log("buzzer_timed_out", "received on", room.name, message);
            if (message.playerId === this.state.myId) this.resetGuess();
        });

        room.onMessage(CatchphraseServerOutMessages.PlayerBuzzedIn, (message) => {
            console.log("player_buzzed_in", "received on", room.name, message);
        });

        room.onMessage(CatchphraseServerOutMessages.CancelBuzzIn, (message) => {
            console.log("cancel_buzz_in", "received on", room.name, message);
            this.setState({ buzzingIn: false });
        });

        room.onMessage(CatchphraseServerOutMessages.GridSegmentSelected, (message) => {
            console.log("grid_segment_selected", "received on", room.name, message);
            this.setState({ buzzingIn: false });
        });

        room.onMessage("host_joined_lobby", (message) => {
            console.log("host_joined_lobby", "received on", room.name, message);
            this.goToLobby();
        });

        // Handle change_game from server (return to lobby flow)
        room.onMessage("change_game", (message) => {
            console.log("[Client] change_game received:", message);
            this.goToLobby(message?.lobbyCode);
        });

        room.onError((code, message) => {
            console.log(this.client.id, "couldn't join", room.name);
        });

        room.onLeave((code) => {
            console.log(this.client.id, "left", room.name, "code:", code);
            if (this.locationCheckInterval) clearInterval(this.locationCheckInterval);
            this.setState({ connected: false });

            // If already redirecting intentionally, don't fight it
            if (this.state.redirect || this.state.redirectURL) {
                return;
            }

            const nowOffline = typeof navigator !== "undefined" && navigator.onLine === false;

            if (!nowOffline && isTerminalByCode(code)) {
                // Terminal code (room disposed, player removed, etc.) — go to lobby
                this.setState({ isReconnecting: false });
                this.goToLobby();
            } else {
                // Retryable code or offline — schedule reconnect with appropriate delay
                const delay = nowOffline ? 3000 : retryDelayForCode(code);
                this.setState({ isReconnecting: true });
                this.scheduleReconnect(delay);
            }
        });
    };

    doReconnect = () => {
        let reconnectToken = this.getQueryStringValue("reconnect");
        const roomCode = this.getRoomCodeFromURL();

        // If no reconnect token in URL, check localStorage (covers QR re-scan / tab close)
        if ((!reconnectToken || !reconnectToken.includes(':')) && localStorage.getItem('catchphrase_reconnectToken')) {
            const storedToken = localStorage.getItem('catchphrase_reconnectToken');
            if (storedToken && storedToken.includes(':')) {
                console.log(`[Client] No reconnect token in URL, using stored token from localStorage`);
                reconnectToken = storedToken;
            }
        }

        // Validate token belongs to the current room code — prevents reconnecting to an old room
        // when GameCity redirects a player to a different game.
        // Note: reconnection token format is "colyseusRoomId:sessionId" (NOT roomCode),
        // so we compare against the stored room code saved alongside the token.
        if (reconnectToken && roomCode) {
            const storedRoomCode = localStorage.getItem('catchphrase_tokenRoomCode');
            if (storedRoomCode && storedRoomCode !== roomCode) {
                console.log(`[Client] Stale token (room ${storedRoomCode}) doesn't match current room (${roomCode}) — clearing`);
                localStorage.removeItem('catchphrase_reconnectToken');
                localStorage.removeItem('catchphrase_sessionId');
                localStorage.removeItem('catchphrase_tokenRoomCode');
                reconnectToken = null;
            }
        }

        console.log(`[Client] ReconnectToken: ${reconnectToken}, RoomCode: ${roomCode}`);

        // If we have a reconnect token, try reconnecting first (even if we also have a room code)
        if (reconnectToken && reconnectToken.includes(':')) {
            this.client.reconnect(reconnectToken).then(room => {
                console.log(`[Client] Reconnected to room ${room.name}`);
                this.setState({
                    room: room,
                    roomId: room.roomId,
                    myId: room.sessionId,
                    reconnectionToken: room.reconnectionToken,
                });
                this.updateToken(room.reconnectionToken, room.sessionId);
                room.send("update_player_token", { reconnectionToken: room.reconnectionToken });
                this.setupRoomListeners(room);
            }).catch(e => {
                console.warn('[Client] Reconnect failed:', e.message);
                const nowOffline = typeof navigator !== "undefined" && navigator.onLine === false;

                if (isTerminalReconnectError(e)) {
                    // Terminal error — clear stale token and try joinRoomByCode as fallback
                    localStorage.removeItem('catchphrase_reconnectToken');
                    localStorage.removeItem('catchphrase_tokenRoomCode');
                    if (roomCode) {
                        console.log(`[Client] Terminal error, falling back to join by code: ${roomCode}`);
                        this.joinRoomByCode(roomCode);
                    } else {
                        this.setState({ connected: false, isReconnecting: false });
                        this.goToLobby();
                    }
                } else {
                    // Transient error — schedule retry
                    this.scheduleReconnect(nowOffline ? 3000 : 2000);
                }
            });
            return;
        }

        // No reconnect token available — join by room code or show error
        if (roomCode) {
            console.log(`[Client] No reconnect token, joining room by code: ${roomCode}`);
            this.joinRoomByCode(roomCode);
        } else {
            console.error('[Client] No valid reconnection token or room code provided');
            this.setState({ hasErrored: true });
        }
    }

    renderAnswerView(viewState, player, team, players, showBuzzedInPlayer) {
        const areYouBuzzedIn = player.catchphraseData?.isBuzzedIn;
        const catchphraseData = this.state.roomState?.catchphraseData;
        const gridSelectionActive = catchphraseData?.gridSelectionActive;
        const buzzedInPlayer = showBuzzedInPlayer && players.find(p => p.catchphraseData?.isBuzzedIn);
        const lockedOut = this.state.buzzingIn || !team || team.lockedOut || team.answered || team.cooldownRunning || player.catchphraseData?.passed;
        const isProcessing = catchphraseData?.isProcessingAnswer && catchphraseData?.processingPlayerId === this.state.myId;
        const hideVoice = catchphraseData?.isMoneyDrop && players?.filter(p => p.connected).length > 1;
        const answerMode = catchphraseData?.answerMode || "fuzzy";
        const isExactMode = answerMode === "exact";

        // Exact mode keeps the buzz-in race but the LetterSlotInput is visible from the
        // moment the phrase timer starts — the cells act as a hint showing the answer's
        // letter-shape before buzz-in. After buzz, the input becomes interactive and the
        // Submit + Give Up buttons appear. Gated on timerRunning so it doesn't appear before
        // the question has actually started (intro / video-loading window).
        const exactPlaying = isExactMode
            && viewState === GameStates.Playing
            && !gridSelectionActive
            && catchphraseData?.timerRunning;
        if (exactPlaying) {
            return <>
                {!areYouBuzzedIn && this.renderBuzzer(viewState, team, areYouBuzzedIn, lockedOut, buzzedInPlayer)}
                {!areYouBuzzedIn && !lockedOut && (
                    <div className={`${styles.pass} ${styles.show}`}>
                        <div className={styles.passOuter}>
                            <button onClick={this.signalPass}>{this.renderTextDiv("PASS")}</button>
                        </div>
                    </div>
                )}
                {areYouBuzzedIn && (
                    <div className={`${styles.timer} ${styles.show}`}>{this.formatTimerDisplay(player)}</div>
                )}
                <LetterSlotInput
                    skeleton={catchphraseData?.currentAnswerSkeleton || ""}
                    buzzed={areYouBuzzedIn}
                    lockedOut={lockedOut}
                    registerFocus={(fn) => { this._focusLetterSlots = fn; }}
                    onSubmit={(text) => this.state.room?.send(CatchphraseServerInMessages.PlayerGuessed, { guess: text })}
                    onGiveUp={this.signalPass}
                    renderTextDiv={this.renderTextDiv.bind(this)}
                />
            </>;
        }

        return <>
            <div className={`${styles.timer} ${viewState === GameStates.Playing && areYouBuzzedIn && !gridSelectionActive && styles.show}`}>{this.formatTimerDisplay(player)}</div>
            <div className={`${styles.pass} ${viewState === GameStates.Playing && !areYouBuzzedIn && !lockedOut && !gridSelectionActive && styles.show}`}>
                <div className={styles.passOuter}>
                    <button onClick={this.signalPass}>{this.renderTextDiv("PASS")}</button>
                </div>
            </div>

            {/* Free text answer section — shown when buzzed in (hidden during grid selection) */}
            <div className={`${styles.answerSection} ${viewState === GameStates.Playing && areYouBuzzedIn && !gridSelectionActive && styles.show} ${isProcessing && styles.processing}`}>
                {isProcessing && (
                    <div className={styles.processingOverlay}>
                        {this.renderTextDiv("Checking your answer...")}
                    </div>
                )}

                <input
                    ref={this.inputRef}
                    type="text"
                    className={styles.answerInput}
                    value={this.state.answerText}
                    onChange={(e) => this.setState({ answerText: e.target.value })}
                    onKeyDown={this.handleAnswerKeyDown}
                    placeholder="Type your answer..."
                    maxLength={60}
                    autoComplete="off"
                    autoCapitalize="off"
                    spellCheck={false}
                    tabIndex={areYouBuzzedIn ? 0 : -1}
                    disabled={!areYouBuzzedIn || isProcessing}
                />

                <div className={styles.buttonRow}>
                    <button className={`${styles.answerButton} ${styles.giveUp}`} onClick={this.signalPass} disabled={isProcessing}>
                        {this.renderTextDiv("GIVE UP")}
                    </button>
                    <button className={`${styles.answerButton} ${styles.confirm}`} onClick={this.handleTextSubmit} disabled={!this.state.answerText.trim() || isProcessing}>
                        {this.renderTextDiv("SUBMIT")}
                    </button>
                </div>

                {!hideVoice ? (<>
                    <div className={styles.divider}>
                        <span>OR</span>
                    </div>

                    <button
                        className={`${styles.voiceButton} ${this.state.isRecording && styles.recording}`}
                        onPointerDown={this.startRecording}
                        onPointerUp={this.stopRecording}
                        onPointerCancel={(e) => { if (this.activePointerId === null) this.stopRecording(e); }}
                        disabled={isProcessing}
                        style={{ touchAction: 'none' }}
                    >
                        <svg className={styles.micIcon} viewBox="0 0 24 24" fill="white">
                            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5z"/>
                            <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
                        </svg>
                        {this.renderTextDiv(this.state.isRecording ? "LISTENING..." : "HOLD TO SPEAK")}
                    </button>
                </>) : (
                    <div className={styles.voiceDisabledMessage}>
                        {this.renderTextDiv("Voice disabled — don't say your answer out loud!")}
                    </div>
                )}
            </div>

            {this.renderBuzzer(viewState, team, areYouBuzzedIn, lockedOut, buzzedInPlayer)}
        </>
    }

    renderRevealAnswerSection(viewState, catchphraseData, teams) {
        const catchphrase = this.getCurrentCatchphrase();
        const wasCorrect = teams.some(t => t.isCorrect);
        const shouldRevealAnswer = wasCorrect || !catchphraseData.isGridPhrase || catchphraseData.revealCount === catchphraseData.currentGridReveal?.length;
        const answer = shouldRevealAnswer ? catchphrase?.answers[0].replace(/\b\w/g, l => l.toUpperCase()) : "???";
        return (
            <div className={`${styles.revealAnswerSection} ${viewState === GameStates.RevealAnswer && !catchphraseData.hideAnswer && styles.show}`} >
                {this.renderTextDiv("The answer was:", styles.instruction)}
                {this.renderTextDiv(answer, styles.answer)}
            </div>
        )
    }

    renderRoundSummarySection(viewState, catchphraseData, team) {
        return (
            <div className={`${styles.roundSummarySection} ${viewState === GameStates.RoundSummary && styles.show}`} >
                {this.renderTextDiv(team?.playerIds?.length === 0 ? "Your Score" : "Team Score", styles.instruction)}
                {this.renderTextDiv(team?.score, styles.score)}
                {this.renderTextDiv(`Round ${catchphraseData.round} over`, styles.instruction)}
            </div>
        )
    }


    renderBuzzer(viewState, team, areYouBuzzedIn, lockedOut, buzzedInPlayer) {
        //const buzzedInTeams = teams.filter(t => t.isBuzzedIn);
        //const preventMultipleBuzzin = buzzedInTeams.length > 0 && !catchphraseData?.isMoneyDrop
        const gridSelectionActive = this.state.roomState?.catchphraseData?.gridSelectionActive;
        return (
            <div className={`${styles.buzzer} ${viewState === GameStates.Playing && !areYouBuzzedIn && styles.show} ${team?.isBuzzedIn && styles.teamBuzzedIn} ${gridSelectionActive && styles.gridSelect}`}>
                <div className={`${styles.buzzerInstruction} ${gridSelectionActive && !lockedOut && styles.show}`}>
                    {this.renderTextDiv("SELECT A SEGMENT")}
                </div>
                <div className={styles.buzzerOuter}>
                    <button onClick={() => this.signalbuzzIn()} disabled={this.state.buzzingIn || lockedOut}>
                        <div className={styles.lockedMessage}>LOCKED</div>
                        <div className={`${styles.cooldown} ${team?.cooldownRunning && team?.cooldown && styles.show}`}>{Math.max(0, team?.cooldown)}s</div>
                    </button>
                </div>
                <div className={`${styles.buzzedInPlayer} ${buzzedInPlayer && styles.show}`}>
                    {`${buzzedInPlayer?.name} has buzzed in`}
                </div>
            </div>
        )
    }


    renderSelectingTeamsView(viewState, player, players, teams) {
        return (
            <div className={`${styles.teamSelect} ${viewState === GameStates.SelectingTeams && styles.show}`} >
                {this.renderTextDiv(<>WHICH TEAM WOULD<br />YOU LIKE TO BE ON?</>, styles.instruction)}
                {
                    teams.map((team, index) => {
                        return <div className={`${styles.teamSelectButtonWrapper}`} key={"team-" + index}>
                            <button
                                className={`${styles.teamSelectButton} ${index === player.catchphraseData?.teamIndex && styles.selected}`}
                                onClick={() => this.signalSelectedTeam(index)}
                                style={{ "--team-colour": team.colour }}
                            >
                                {this.renderTextDiv(team.name)}
                            </button>
                        </div>
                    })
                }
                <button className={`${styles.mainButton} ${styles.smaller} ${this.validateTeams(players, teams) && player?.primaryPlayer && styles.show}`} onClick={this.signalFinishTeamsSelection}>
                    {this.renderTextDiv("Confirm Teams")}
                </button>
            </div>
        )
    }

    renderRoundIntroView(viewState, catchphraseData, player, waitingForHost) {
        const showSkip = player?.primaryPlayer && !this.state.roomState.catchphraseData?.introSkipped && !waitingForHost;
        const round = catchphraseData.round;
        const subTitle = round === 1 ? "FIRST ROUND" : round === 2 ? "SECOND ROUND" : "FINAL ROUND";
        const title = round === 1 ? <>POINT<br />PURSUIT</> : round === 2 ? <>QUICK<br />FIRE</> : <>CRUNCH<br />TIME</>;
        return (
            <div className={`${styles.roundIntroSection} ${viewState === GameStates.RoundIntro && styles.show}`} >
                <div className={styles.titles}>
                    {this.renderTextDiv(subTitle, styles.subTitle)}
                    {this.renderTextDiv(title, styles.title)}
                </div>
                {this.renderTextDiv("Get ready to play!", styles.instruction)}
                <button className={`${styles.mainButton} ${styles.smaller} ${showSkip && styles.show}`} onClick={this.signalSkipIntro}>
                    {this.renderTextDiv("Skip Intro")}
                </button>
            </div>
        )
    }

    validateTeams(players, teams) {
        const allPlayersInTeams = players.filter(p => p.connected).every(p => p.catchphraseData?.teamIndex > -1);
        const teamsWithPlayers = teams.filter(t => t.playerIds.length > 0);
        return allPlayersInTeams && teamsWithPlayers.length >= 2;
    }

    renderStartButtons(viewState, player, waitingForHost) {
        const show = player?.primaryPlayer && viewState === GameStates.MainMenu && !waitingForHost;
        return (
            <div className={`${styles.startButtonSection} ${show && styles.show}`}>
                <button className={`${styles.mainButton}`} onClick={() => this.signalStartGame(false)}>
                    {this.renderTextDiv("Start Game")}
                </button>
                <button className={`${styles.mainButton} ${styles.smaller} ${styles.alt}`} onClick={this.signalGoToLobby}>
                    {this.renderTextDiv("Return To Lobby")}
                </button>
                {/*<div className={styles.toggle}>*/}
                {/*    <input className={styles.checkbox} type="checkbox" id="checkbox" name="checkbox" onChange={this.toggleSkipTutorial} />*/}
                {/*    <label htmlFor="checkbox" className={styles.text}>Skip Tutorial*/}
                {/*        <div className={styles.face}>Skip Tutorial</div>*/}
                {/*    </label>*/}
                {/*</div>*/}
            </div>
        )
    }

    renderTutorial(viewState) {
        return (
            <div className={`${styles.tutorialSection} ${viewState === GameStates.Tutorial && !this.state.voteSkipTutorial && styles.show}`}>
                <button className={`${styles.mainButton}`} onClick={this.skipTutorial}>
                    {this.renderTextDiv("Skip Tutorial")}
                </button>
            </div>
        )
    }

    renderGameConfigView(viewState, player, players, catchphraseData, waitingForHost) {
        // Keep the view mounted so it can animate out; .show class on the container is driven
        // by the show prop and CSS handles the slide / fade + visibility-hidden-when-out.
        const show = viewState === GameStates.GameConfig && !waitingForHost;
        const editorId = catchphraseData?.configEditorId || "";
        const isEditor = editorId === this.state.myId;
        const editor = editorId ? players?.find(p => p.id === editorId) : null;
        const editorName = editor?.name || "";
        return (
            <GameConfigEditor
                show={show}
                catchphraseData={catchphraseData}
                isEditor={isEditor}
                editorName={isEditor ? "" : editorName}
                playerCount={players?.length ?? 0}
                onUpdate={this.signalUpdateGameConfig}
                onBack={this.signalBackToMenu}
                onStart={this.signalConfirmGameConfig}
                onClaimEditor={this.signalClaimEditor}
                renderTextDiv={this.renderTextDiv.bind(this)}
            />
        );
    }

    renderTextDiv(text, additionalStyles) {
        return <>
            <div className={`${styles.text} ${additionalStyles}`}>{text}
                <div className={styles.face}>{text} </div>
            </div>
        </>
    }

    renderPlayerSection(viewState, player, team) {
        const centerPlayer = [GameStates.Loading, GameStates.MainMenu].includes(viewState);
        const lockedOut = this.state.buzzingIn || team?.lockedOut || team?.answered;
        // GameConfig: keep mounted and apply .hidden so the avatar animates out (and back in
        // when leaving config) instead of just popping.
        const isConfig = viewState === GameStates.GameConfig;
        return (
            <div className={`${styles.playerSection} ${centerPlayer && styles.center} ${isConfig && styles.hidden}`}>
                {
                    player && player.id &&
                    <Player player={player} room={this.state.room} team={team} lockedOut={lockedOut} large={centerPlayer} />
                }
            </div>
        )
    }

    renderEndGameSection(viewState, player, team) {
        const highestScore = this.state.roomState.catchphraseData.teams.reduce((max, t) => t.score > max ? t.score : max, 0);
        const winners = this.state.roomState.catchphraseData.teams.filter(t => t.score === highestScore);
        const areYouAWinner = winners.some(t => t.playerIds.find(id => id === this.state.myId));
        const comment = areYouAWinner ? "WELL DONE!" : "OH DEAR!";
        const winnerMessage = areYouAWinner ?
            team?.playerIds.length > 1 ? <>YOUR TEAM<br />HAS WON</> : <>YOU ARE<br />THE WINNER</> :
            team?.playerIds.length === 1 ? <>YOUR TEAM<br />HAS LOST</> : <>YOU HAVE<br />LOST</>;

        return (
            <div className={`${styles.endGameSection} ${viewState === GameStates.EndGame && styles.show}`}>
                {this.renderTextDiv(comment, styles.comment)}
                {this.renderTextDiv(winnerMessage, styles.winnerMessage)}
                <div className={`${styles.buttons} ${player?.primaryPlayer && styles.show}`}>
                    <button className={`${styles.mainButton}`} onClick={this.signalPlayAgain}>
                        {this.renderTextDiv("Play Again")}
                    </button>
                    <button className={`${styles.mainButton} ${styles.smaller} ${styles.alt}`} onClick={this.signalGoToLobby}>
                        {this.renderTextDiv("Return to Lobby")}
                    </button>
                </div>
                <img src={Trophy} className={`${styles.trophy} ${areYouAWinner && styles.show}`} alt="trophy" />
            </div>
        )
    }

    renderStartWarning() {
        return (
            this.state.showStartWarning &&
            <ErrorModal
                title={"Are you ready to play?"}
                styles={"d-flex"}
                message={"It looks like all the players might not be connected to the game, are you sure you would like to start?"}
                callback={this.closeStartWarning}
                callbackText={"No"}
                callback2={this.props.gameState === GameStates.EndGame ? this.confirmPlayAgain : this.confirmStartGame}
                callbackText2={"Yes"}
            />
        )
    }

    renderLogoSection(viewState) {
        const logoShowStates = [GameStates.MainMenu];
        return (
            <div className={`${styles.logoSection} ${logoShowStates.includes(viewState) && styles.show}`}>
                <img src={logo} className={styles.logo} alt="logo" />
            </div>
        )
    }

    render() {
        //#region Handle Redirect
        if (this.state.redirectURL && !(process.env.NODE_ENV === "development" && this.state.hasErrored)) {
            return (
                <React.Fragment>
                    <div id="gameContainer" className={styles.gameContainer}>
                        <div className={styles.loadingContainer}>
                            <Loading loadingText={"Sending you to the lobby!"} />
                        </div>
                    </div>
                    <div style={{ opacity: 0 }}>
                        <Route path="/" render={() => (window.location = this.state.redirectURL)} />
                    </div>'
                </React.Fragment>
            )
        }
        //#endregion

        const catchphraseData = this.state.roomState?.catchphraseData;
        const player = this.state.roomState?.players.get(this.state.myId);
        console.log("Player : ", player);
        const viewState = this.getCurrentViewState(player);
        const teams = catchphraseData?.teams;
        const team = teams && player?.catchphraseData?.teamIndex != null ? teams[player.catchphraseData.teamIndex] : null;
        const players = this.state.roomState?.players ? Array.from(this.state.roomState.players.values()) : null;
        const waitingForHost = !this.state.hostConnected || catchphraseData?.waitingForHost;
        return <>
            {
                catchphraseData && player && player.catchphraseData && this.state.connected ?
                    <div id="clientContainer" className={`${styles.clientContainer}`} style={{ "--player-colour": team ? team.colour : "grey" }} >
                        <ClientMenuIcon room={this.state.room} gameState={viewState} showHints={this.state.showHints} onHelpClick={() => this.setState(s => ({ showHints: !s.showHints }))} />
                        {this.renderLogoSection(viewState)}
                        {this.renderStartButtons(viewState, player, waitingForHost)}
                        {this.renderTutorial(viewState)}
                        {this.renderGameConfigView(viewState, player, players, catchphraseData, waitingForHost)}
                        {this.renderSelectingTeamsView(viewState, player, players, teams)}
                        {this.renderRoundIntroView(viewState, catchphraseData, player, waitingForHost)}
                        {this.renderPlayerSection(viewState, player, team)}
                        {this.renderAnswerView(viewState, player, team, players, catchphraseData.isMoneyDrop)}
                        {/*this.renderRevealAnswerSection(viewState, catchphraseData, teams)*/}
                        {this.renderRoundSummarySection(viewState, catchphraseData, team)}
                        {this.renderEndGameSection(viewState, player, team)}

                        {this.renderStartWarning()}
                        <Hints show={this.state.showHints} onClose={() => this.setState({ showHints: false })} />
                    </div>
                    :
                    <Loading loadingText={"Connecting you to the game..."} noBg={false} hideLoader={false} />
            }

            {this.renderDebugButtons()}

        </>
    }

    //#region Debugging
    renderDebugButtons() {
        return null;
        if (window.location.hostname !== "localhost") return;
        return (
            <div style={{ position: "absolute", zIndex: 999, pointerEvents: 'initial', fontSize: "10px" }}>
                <button onClick={() => this.setState({ connected: true })}>Connect</button>
                <button onClick={() => this.testingSetCatchphraseDataState({ gameState: GameStates.Loading })}>Loading</button>
                <button onClick={() => this.testingSetCatchphraseDataState({ gameState: GameStates.MainMenu })}>MainMenu</button>
                <button onClick={() => this.testingSetCatchphraseDataState({ gameState: GameStates.Tutorial })}>Tutorial</button>
                <button onClick={() => this.testingSetCatchphraseDataState({ gameState: GameStates.GameConfig })}>GameConfig</button>
                <button onClick={() => this.testingSetCatchphraseDataState({ gameState: GameStates.RoundIntro })}>RoundIntro</button>
                <button onClick={() => this.testingSetCatchphraseDataState({ gameState: GameStates.SelectingTeams })}>SelectingTeams</button>
                <button onClick={() => this.testingSetCatchphraseDataState({ gameState: GameStates.Playing })}>Playing</button>
                <button onClick={() => this.testingSetCatchphraseDataState({ gameState: GameStates.RevealAnswer })}>RevealAnswer</button>
                <button onClick={() => this.testingSetCatchphraseDataState({ gameState: GameStates.RoundSummary })}>RoundSummary</button>
                <button onClick={() => this.testingSetCatchphraseDataState({ gameState: GameStates.EndGame })}>EndGame</button>
                <button onClick={() => this.testingBuzzIn()}>TestBuzzIn</button>
            </div>
        )
    }

    testingSetCatchphraseDataState(state) {
        this.setState({ roomState: { ...this.state.roomState, catchphraseData: { ...this.state.roomState.catchphraseData, ...state } } });
    }

    testingBuzzIn() {
        const team = this.state.roomState.catchphraseData.teams.at(0);
        team.isBuzzedIn = !team.isBuzzedIn;
        const player = this.state.roomState.players.values().toArray()[0];
        player.catchphraseData.isBuzzedIn = !player.catchphraseData.isBuzzedIn;
        this.setState({ roomState: { ...this.state.roomState } });
    }
    //#endregion
}
